module.exports = __webpack_public_path__ + "img/ic_sort.d38b7ebc.svg";